import _  from 'lodash';

const FileUpload = ($state, $rootScope) => ({
    restrict: "A",
    link: function ($scope, $element) {
        let fileName;
        let el = $element.find('input');

        function checkExtension(fileName) {
            const y = fileName.split(".");
            let extension = y[(y.length)-1];

            return ['igs', 'stl'].indexOf(extension.toLocaleLowerCase()) !== -1;
        }

        function checkSize(file) {
            return file.size < 15 *1048576;
        }

        function updateModel (e) {
            fileName = _.get(e, 'target.files[0].name', false);
            if (fileName) {
                if(!checkExtension(fileName)) {
                    $rootScope.$broadcast('meshError', "Wrong file format, only .igs and .stl files are allowed.");
                } else if (!checkSize(e.target.files[0])) {
                    $rootScope.$broadcast('meshError', "File is too big, maximum file size is 15MB.");
                } else {
                    $rootScope.$broadcast('fileLoaded', {
                        mesh: "",
                        fileName: fileName,
                        rawData: e.target.files[0]
                    });
                    $rootScope.$broadcast('meshError', undefined);
                }
                el[0].value = "";
            }
        }

        el.bind('change', updateModel);
    }
});

FileUpload.$inject = ['$state', '$rootScope', 'LoadedModel'];

export default FileUpload;



// WEBPACK FOOTER //
// ./client/app/common/file-upload/file-upload.directive.js